module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete"
  }, [(_vm.options.length && _vm.showPanel) ? _c('div', {
    staticClass: "options"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      key: index,
      staticClass: "option",
      on: {
        "click": function($event) {
          _vm.selectOption(option)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.itemName ? option[_vm.itemName] : option) + "\n    ")])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-686aad07","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/autocomplete.vue
// module id = 1757
// module chunks = 180